import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Box, Link } from "@mui/material";
import { GlobalContext } from "../../Context/GlobalContext";
import ScheduleIcon from "../ScheduleIcon/ScheduleIcon";
import { ALTA_CENTRO } from '../../Constants/Global';

/**
 * A component that renders a single task or process item in a menu list. It supports different display styles
 * based on the context (e.g., calendar, forms) and handles click events to open modals for task or process details.
 * 
 * @component
 * @example
 * import MenuListTasks from "../MenuListTasks/MenuListTasks";
 * <MenuListTasks item={taskItem} tagType="calendar" />
 * @param {Object} props - The component props.
 * @param {Object} props.item - The task or process item to display.
 * @param {string} props.item.type - The type of the item (e.g., "process", "subprocess").
 * @param {string} props.item.name - The name of the task or process.
 * @param {string} props.item.id - The unique identifier of the task or process.
 * @param {string} props.item.process - The process name (for subprocesses).
 * @param {string} props.item.label - The label of the task or process.
 * @param {number} props.item.schedule - The number of days left for the task or process.
 * @param {string} props.item.statusId - The status of the task or process.
 * @param {string} props.tagType - The context in which the item is displayed (e.g., "calendar", "forms").
 * @returns {React.Fragment} The rendered task or process item component.
 */
function MenuListTasks(props) {
  const {setModalAltaCentroOpen, setModalAltaCentroData, setModalOpen, setModalData, setProcessModalOpen, userProperties} = React.useContext(GlobalContext);
  /*const {setModalOpen, setModalData, setProcessModalOpen, userProperties} = React.useContext(GlobalContext);*/
  const {item, tagType} = props;


  /**
   * Handles the click event for the menu item. Opens a modal to display details of the task or process.
   *
   * @param {Object} itm - The task or process item.
   */
  const onClickOptionHandler = (itm) => {
    setModalData(itm);


    if (itm.subprocessId === ALTA_CENTRO){
        console.log("itm: ",itm);
       setModalAltaCentroOpen(true);
    }
    else if (itm.type === "process"){
      setProcessModalOpen(true);
    }
    else {
        console.log("MODAL", itm.name);
        setModalOpen(true)
    }
  };

  /**
   * Handles the click event for a process link. Opens the process modal and closes the task modal.
   * 
   * @param {Object} itm - The process item.
   */
  const onClickProcessLink = (itm) => {
    setModalData(itm);
    setModalOpen(false);
    setModalAltaCentroOpen(false);
    setProcessModalOpen(true);
  }

  // Generate the title for the task or process
  let tagTitle = "";
  if (item.type === "subprocess"){
    tagTitle = "[" + item.process.slice(0, 2).toUpperCase() + item.label + "] " + item.name;
  } else {
    tagTitle = item.name + " " + item.id;
  }

  // Generate the display name for the task or process
  let tagName = "";  
  if (userProperties.viewProcesses && tagType === "forms" && item.type === "subprocess") {
    const processLink = "[" + item.process.slice(0, 2).toUpperCase() + item.label + "]";
    tagName = <><Link onClick={onClickProcessLink.bind(null, item)} sx={{cursor: "pointer"}}>{processLink}</Link> {item.name}</>
  } else {
    tagName = tagTitle;
  }

  /**
   * Applies ellipsis styling for text overflow if the context is not "forms".
   * 
   * @returns {Object} The CSS styles for ellipsis.
   */
  const ellipsisStyle = () => {
    if (tagType !== "forms") {
      return {width: "98%", overflow: "hidden", textOverflow: "ellipsis"}
    }
  }

  // Determine the color for the tag based on the item type
  const tagColor = item.type === "subprocess" ? "orange": "cornflowerblue";
  //const tagColor = item.type === "subprocess" ? "green": "cornflowerblue";

  let backGroundColor = item.departmentColor; //"lightgreen";
  //const textColor = backGroundColor === "#FFC107" ? "black" : "white";
  const textColor = "black";
  //console.log("item: ",item);


  // Define styles based on the context (e.g., calendar, forms)
  let styles = {};
  if (tagType === "calendar") {
    styles = {
      border: `solid 1px ${tagColor}`, 
      borderRadius: "8px",
      height: "24px",
      margin: "0",
      fontSize: "12px",
      background: `${backGroundColor}`,
      color: `${textColor}`

    };
  } else if (tagType === "forms" ){
    styles = {
      border: `solid 1px ${tagColor}`, 
      borderRadius: "14px",
      height: "45px",
      margin: "0 0 8px 0",
      fontSize: "14px",
      background: `${backGroundColor}`,
      color: `${textColor}`,
      cursor: "unset"
    };
  } else{
    styles = {
      border: `solid 1px ${tagColor}`, 
      borderRadius: "14px",
      height: "45px",
      margin: "0 0 8px 0",
      fontSize: "14px",
      background: `${backGroundColor}`,
      color: `${textColor}`
    };
  }

  return (
    <MenuItem 
    onClick={onClickOptionHandler.bind(null, item)}
    sx={{...styles}}
    >
      <Box style={ellipsisStyle()} title={tagTitle}>{tagName}</Box> <ScheduleIcon daysLeft={item.schedule} status={item.statusId} fromCalendar={tagType === "calendar"}/>
    </MenuItem>
  );
}

export default MenuListTasks;